import { gql } from 'apollo-angular';
import { attachedFileFragment } from '../upload/upload.fragments';

export const learningResourceMicroLearningMinimal = gql`
  fragment LearningResourceMicroLearningMinimal on LearningResourceMicroLearning {
    id
    title
    description
    image {
      ...AttachedFile
    }
    microLearningStatus
  }
  ${attachedFileFragment}
`;
